import React, { useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { MarketplaceGrid } from '@features/connections/generic/components/MarketplaceGrid';
import DialogHeader from '@shared/ui/dialog/DialogHeader';
import { Connection } from '@domain/connection/models/Connection';
import { useConnections } from '@shared/hooks';
import { useTutorialStore } from '../../../application/store/TutorialStore';
import { APP_CONFIG } from '../../../config/app.config';
import { Icon, IconSize } from '@shared/icons';
import OnboardingStepCard from '../shared/OnboardingStepCard';
import { ConnectionListItem } from '@features/connections/generic/components/ConnectionListItem';

interface FinishedStepProps {
  onAddConnection: () => void;
}

const FinishedStep: React.FC<FinishedStepProps> = ({ onAddConnection }) => {
  const navigate = useNavigate();
  const colors = APP_CONFIG.ui.theme.colors;
  const { connections } = useConnections();
  const [isAddConnectionDialogOpen, setIsAddConnectionDialogOpen] = useState(false);
  const { markStepCompleted, completeUnlockDashboard } = useTutorialStore();

  const handleStartSetup = () => {
    markStepCompleted('marketplace-connection');
    completeUnlockDashboard();
    navigate('/dashboard');
  };

  const handleNewConnection = (_connection: Connection) => {
    setIsAddConnectionDialogOpen(false);
    onAddConnection();
  };

  return (
    <>
      <OnboardingStepCard
        title="All your data has been imported"
        subtitle="You're now ready to further set up your account"
        isActive
        isCompleted
        footer={
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Button
              variant="text"
              onClick={() => setIsAddConnectionDialogOpen(true)}

            >
              Add another store
            </Button>

            <Button variant="contained" onClick={handleStartSetup}>
              Start setting up
            </Button>
          </Box>
        }
      >
        <Stack direction="column" overflow="auto" sx={{ border: 1, borderColor: colors.border, borderRadius: '16px' }}>

          <Stack
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            overflow="auto"
          >
            {connections?.map((connection) => (
              <Box key={connection.id} width="100%" display="flex" alignItems="flex-start">
                <ConnectionListItem connection={connection} />
              </Box>
            ))}
          </Stack>

        </Stack>
      </OnboardingStepCard>

      <Dialog
        open={isAddConnectionDialogOpen}
        onClose={() => setIsAddConnectionDialogOpen(false)}
      >
        <DialogHeader>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Add a connection</Typography>
            <IconButton onClick={() => setIsAddConnectionDialogOpen(false)}>
              <Icon icon="X01" />
            </IconButton>
          </Stack>
        </DialogHeader>
        <DialogContent>
          <MarketplaceGrid onNewConnection={handleNewConnection} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FinishedStep;
